
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button"
import { useMemo, useState } from "react"
import './Accordion.scss';

interface PropsAccordion {
    name:string
    visible:boolean
    setter: () => void
    bin:boolean
    deleteElement?: () => void
}

export const CustomAccordion = ({name,visible,setter,bin,deleteElement}:PropsAccordion) => {
    const [arrow,setArrow] = useState("../../../assets/images/icon-ui-triangle-right.svg")

    const arrowUp = require("../../../assets/images/icon-ui-triangle-right.svg");
    const arrowDown = require("../../../assets/images/icon-ui-triangle-down.svg");
    const trash = require("../../../assets/images/icon-trash.svg");

    useMemo(() => {
        if(!visible){
            setArrow(arrowUp.default)  
        }else{
            setArrow(arrowDown.default)
        }
    },[visible])

    return <>
    <div className="flex">
        <div className="flex align-items-center justify-content-center">
                <img src={arrow} className="arrow" onClick={() => setter()}></img>
        </div>
        <div  className="flex-2 mb-3 mr-3 ml-3 mt-2 align-items-center justify-content-center Profil-Personnel">
            {name}
        </div>
        {
            // bin && <div className="button-bin mt-3"><FontAwesomeIcon className="colorOnHover" icon="trash" style={{color:"#08365e" }} size="lg"/></div>
            bin && <div className="button-bin mt-2"><img src={trash.default} className="colorOnHover" onClick={deleteElement} ></img></div>
        }

                


    </div>
    <div className="Rectangle mb-3"></div>
    </>
}